import { coerceDate } from "./time";

/**
 * THE canonical half-open interval-overlap predicate for the whole app: do the
 * time ranges [aStart, aEnd) and [bStart, bEnd) intersect?
 *
 * Endpoints may be Date | millisecond-number | ISO-string | Firestore Timestamp
 * (anything `coerceDate` understands). Returns `false` if any endpoint is
 * missing/unparseable, or if either interval is degenerate (end <= start) — a
 * zero-length or inverted interval overlaps nothing.
 *
 * This is the single definition behind every "do two time windows overlap"
 * check in the codebase: the availability conflict pip (overlap.js#timesOverlap),
 * the slot-overlay classifier (slot-overlay-classify.js#rangesOverlap), the
 * calendar overlay-lane layout (calendar-overlay-layout.js), the busy-window
 * blocker (conflict-utils.js#findBlockingWindow) and the copy-votes planner
 * (copy-votes.js). Keeping the math in one place stops the surfaces from
 * drifting on boundary/degenerate handling.
 */
export function intervalsOverlap(aStart, aEnd, bStart, bEnd) {
  const as = coerceDate(aStart);
  const ae = coerceDate(aEnd);
  const bs = coerceDate(bStart);
  const be = coerceDate(bEnd);
  if (!as || !ae || !bs || !be) return false;

  const asMs = as.getTime();
  const aeMs = ae.getTime();
  const bsMs = bs.getTime();
  const beMs = be.getTime();

  // Half-open intervals: a zero/negative-duration window overlaps nothing.
  if (aeMs <= asMs || beMs <= bsMs) return false;

  return asMs < beMs && bsMs < aeMs;
}
